export interface ISidebar {
    dismissPanel(): void;
}

export class SidebarContext {
    constructor(public $implicit: ISidebar) {}
}
